module.exports = __webpack_public_path__ + "fonts/Gilroy-700.17cb930.otf";